import { NgModule, ModuleWithProviders } from '@angular/core';

import { Theme } from './enums';
import { DEFAULT_THEME, THEME_CONFIG } from './providers';
import { ThemeService } from './services';
import { ThemeConfig } from './types';

@NgModule()
export class ThemeModule {
  public static forRoot(
    config: ThemeConfig,
    defaultTheme: Theme = Theme.Light,
  ): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ThemeService,
        { provide: THEME_CONFIG, useValue: config },
        { provide: DEFAULT_THEME, useValue: defaultTheme },
      ],
    };
  }

  constructor(theme: ThemeService) {}
}
